import api from "./api";

 
export const sellBikeService = {

  // 📦 Get available bikes (for selling)
  getAvailableStock: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/filter-bikes?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 🔍 Find by engine
  findByEngine: async (engine) => {
    try {
      const response = await api.get(`/find-bike-details/${engine}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 💰 Sell bike
  sellBike: async (data) => {
    try {
      console.log(data)
      const response = await api.post("/sell-bike", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

};